import { RefObject, useEffect, useRef } from 'react';

type Props = {
  inputRef: RefObject<HTMLInputElement | null>;
  onKeyUp?: (event: KeyboardEvent) => void;
};

const useInputKeyUpListener = ({ inputRef, onKeyUp }: Props) => {
  const onKeyUpRef = useRef(onKeyUp);
  onKeyUpRef.current = onKeyUp;

  useEffect(() => {
    const el = inputRef.current;
    if (!el) return;
    const handler = (e: KeyboardEvent) => onKeyUpRef.current?.(e);
    el.addEventListener('keyup', handler);
    return () => el.removeEventListener('keyup', handler);
  }, [inputRef]);
};

export default useInputKeyUpListener;
